import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../../AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText, 
  IconButton, 
  Box,
  useTheme
} from '@mui/material';
import { 
  Home as HomeIcon, 
  LocationOn as LocationIcon, 
  Notifications as NotificationsIcon, 
  Logout as LogoutIcon,
} from '@mui/icons-material';
import tLogo from '../../../static/images/orbitallogo.png';
import '../../../static/styles/sidebar.css';

function SideBar() {
  const { logout } = useAuth();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);
  const navigate = useNavigate();
  const theme = useTheme();

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    logout();
    navigate('/login');
  };

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  const BoldListItemText = (props) => (
    <ListItemText
      {...props}
      primaryTypographyProps={{ fontWeight: 'bold',marginBottom:'0px' }}
    />
  );
  
  return (
    <Box
      variant="permanent"
      anchor="left"
      className="side-bar"
    >
      <Box className='side-bar-upper'
        sx={{maxWidth: '195px', border:'none'}}
      >
        <Box className='brand-container'>
          <Link to="/" onClick={() => handleLinkClick('/')}>
            <img
              src={tLogo}
              className='logo'
              alt="logo"
            />
          </Link>
        </Box>
        <List className='side-bar-links'>
          <ListItem
            button
            component={Link}
            to="/"
            className={`nav-link ${activeLink === '/' ? 'active' : ''}`}
            onClick={() => handleLinkClick('/')}
          >
            <ListItemIcon sx={{minWidth: '45px'}}>
              <HomeIcon />
            </ListItemIcon>
            <BoldListItemText primary="Home" sx={{marginBottom:'0px'}} />
          </ListItem>
          <ListItem
            button
            component={Link}
            to="/leak"
            className={`nav-link ${activeLink.startsWith('/leak') ? 'active' : ''}`}
            onClick={() => handleLinkClick('/leak')}
          >
            <ListItemIcon sx={{minWidth: '45px'}}>
              <LocationIcon />
            </ListItemIcon>
            <BoldListItemText primary="Leak" sx={{marginBottom:'0px'}} />
          </ListItem>
         {/* NOTIFICICATIONS */}
          {/*
          <ListItem
            button
            component={Link}
            to="/notifications"
            className={`nav-link ${activeLink.startsWith('/notifications') ? 'active' : ''}`}
            onClick={() => handleLinkClick('/notifications')}
          >
            <ListItemIcon sx={{minWidth: '45px'}}>
              <NotificationsIcon />
            </ListItemIcon>
            <BoldListItemText primary="Notifications" sx={{marginTop:'7px'}} />
          </ListItem>
          */}
        </List>
      </Box>
      <Box className='lower-sidebar'>
        <Box className="logout-container">
          <IconButton
            onClick={handleLogout}
            className='logout-icon'
          >
            <LogoutIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
}

export default SideBar;
